











































































































import { Component, Prop, Vue } from "vue-property-decorator";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import { composeDate, toDateString } from "@/utils/asesmenIntensifDateTime";
import {
  FilterKebidanan,
  ModePeriodeKebidanan,
  OpsiUnitKebidanan,
  filterSiap
} from "@/services/LaporanKebidanan";

@Component({ components: { VCDateTimePicker } })
export default class FilterLaporanKebidanan extends Vue {
  @Prop({ required: true }) readonly value!: FilterKebidanan;
  @Prop({ type: Array, default: () => [] })
  readonly opsiUnit!: OpsiUnitKebidanan[];
  @Prop({ type: Boolean, default: false }) readonly loading!: boolean;
  @Prop({ type: Boolean, default: false }) readonly tanpaCari!: boolean;
  @Prop({ type: Boolean, default: false }) readonly tanpaRuang!: boolean;

  readonly modeOpts = [
    { text: "Bulan", value: "bulanan" },
    { text: "Tahun", value: "tahunan" },
    { text: "Rentang tanggal", value: "rentang" }
  ];

  get tahunOpts(): string[] {
    const kini = new Date().getFullYear();
    const out: string[] = [];
    for (let i = 0; i <= 5; i++) out.push(String(kini - i));
    return out;
  }

  get siap(): boolean {
    return filterSiap(this.value);
  }

  get tanggalDari(): Date | null {
    return composeDate(this.value.tanggal_dari, "00:00");
  }

  set tanggalDari(val: Date | null) {
    this.ubah("tanggal_dari", toDateString(val) || "");
  }

  get tanggalSampai(): Date | null {
    return composeDate(this.value.tanggal_sampai, "00:00");
  }

  set tanggalSampai(val: Date | null) {
    this.ubah("tanggal_sampai", toDateString(val) || "");
  }

  ubah<K extends keyof FilterKebidanan>(
    kunci: K,
    nilai: FilterKebidanan[K]
  ): void {
    this.$emit("input", { ...this.value, [kunci]: nilai });
  }

  ubahMode(mode: ModePeriodeKebidanan): void {
    const kini = new Date();
    const bulan = String(kini.getMonth() + 1).padStart(2, "0");
    let periode = "";

    if (mode === "bulanan") periode = `${kini.getFullYear()}-${bulan}`;
    if (mode === "tahunan") periode = String(kini.getFullYear());

    this.$emit("input", {
      ...this.value,
      mode,
      periode,
      tanggal_dari: "",
      tanggal_sampai: ""
    });
  }

  tampilkan(): void {
    if (this.siap) this.$emit("tampilkan");
  }
}
